import { AUTH0_DOMAIN, AUTH0_CLIENT_ID } from "../configs/constants"

export const AUTH_CONFIG = {
	domain: AUTH0_DOMAIN,
	clientId: AUTH0_CLIENT_ID,
	container: 'auth0-login-container'
};
